<script lang="ts">
export default {
    name: "HomeAlert",
};
</script>

<script setup lang="ts">
import { onUnmounted, watch } from "vue"
import $ from 'jquery'
import { getNearbyList, clickAlert } from "@/api/Local/index"
import { useVueCesium } from 'vue-cesium'
import GPS from '@/utils/gps-convert'
import { store } from '@/store'
import { DeviceTypeName, EBizCode } from "@/types/enum";
import { EModeCode, EDockModeCode, EGear } from '@/types/device'

const $vc = useVueCesium()
const props = defineProps({
    homeEventVisible: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
});

const emits = defineEmits(["update:homeEventVisible"]);

const locationList: any = ref([])
const selectName = ref()
const alarmLocation = ref()
const locationLng = ref()
const locationLat = ref()
const point: any = ref(null)
const theEDockModeCode = reactive(['已断开', '空闲中', '调试中', '远程调试', '升级中', '运行中'])

const selectLocation = (item: any) => {
    selectName.value = item.name
    alarmLocation.value = item.name
    if (item.location) {
        const lng = item.location.split(',')[0]
        const lat = item.location.split(',')[1]
        const centre = GPS.gcj_decrypt(lat, lng)
        locationLng.value = centre.lon
        locationLat.value = centre.lat
    }
}

const uavPop = ref(false)
const airObj = ref()
const deviceOption = ref()
let watchDeviceState: any

const locationBtn = () => {
    if (locationLng.value && locationLat.value) {
        /** 避免多次「搜索」叠加 deep watch，导致内存持续上涨 */
        if (watchDeviceState) {
            watchDeviceState()
            watchDeviceState = undefined
        }
        getNearbyList({ longitude: locationLng.value, latitude: locationLat.value }).then(res => {
            console.log(res)
            if (res.tempJob.length === 0) {
                ElMessage.warning('当前位置附近没有可用设备')
                uavPop.value = false
                deviceOption.value = null
                airObj.value = null
                return
            } else {
                uavPop.value = true
                deviceOption.value = res.tempJob
                console.log(deviceOption.value)
                watchDeviceState = watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
                    // console.log(data)
                    if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[deviceOption.value[0].sn]) {
                        // console.log('设备状态:', data.deviceInfo)
                    }
                    if (data.currentType === DeviceTypeName.Dock && data.dockInfo[deviceOption.value[0].sn]) {
                        // console.log('机场状态:', data.dockInfo[deviceOption.value[0].sn])
                        airObj.value = data.dockInfo[deviceOption.value[0].sn]
                    }
                }, {
                    deep: true
                })
            }
        }).catch(() => {
            return
        })
        $vc.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(locationLng.value, locationLat.value - 0.008, 500), // New York
            orientation: {
                heading: Cesium.Math.toRadians(0.0), // 方向（从正北开始）
                pitch: -0.5001412827126326,
                roll: 0.0 // 滚动角度
            },
            duration: 5.0 // 飞行时间，单位秒
        });
        if (point.value) {
            $vc.viewer.entities.remove(point.value);
        }
        point.value = $vc.viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(locationLng.value, locationLat.value),
            billboard: {
                // 图像地址，URI或Canvas的属性
                image: '/images/zuobiao-pic.png',
                // 设置颜色和透明度
                color: Cesium.Color.WHITE.withAlpha(1),
                // 高度（以像素为单位）
                height: 45,
                // 宽度（以像素为单位）
                width: 47,
                // 逆时针旋转
                rotation: 0,
                // 大小是否以米为单位
                sizeInMeters: false,
                // 相对于坐标的垂直位置
                verticalOrigin: Cesium.VerticalOrigin.CENTER,
                // 相对于坐标的水平位置
                horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                // 该属性指定标签在屏幕空间中距此标签原点的像素偏移量
                pixelOffset: new Cesium.Cartesian2(0, 0),
                // 应用于图像的统一比例。比例大于会1.0放大标签，而比例小于会1.0缩小标签。
                scale: 1.0,
                // 是否显示
                show: true
            }
        });
    }
}

function drawPoint(event: any) {
    if (point.value) {
        $vc.viewer.entities.remove(point.value);
    }
    if (Cesium.defined($vc.viewer)) {
        const cartesian = $vc.viewer.scene.pickPosition(event.position);
        const cartographic = $vc.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
        const coordinates = {
            lat: Cesium.Math.toDegrees(cartographic.latitude),
            lon: Cesium.Math.toDegrees(cartographic.longitude)
        };
        console.log('点位坐标:', coordinates)
        locationLng.value = coordinates.lon
        locationLat.value = coordinates.lat
        // 创建一个Geocode类实例
        // 地理编码函数
        // const { Cesium } = $vc.Cesium.CesiumWidget;
        // const geocoder = new Cesium.Geocoder({
        //   scene: $vc.viewer.scene,  
        // });
        // geocoder.pickPosition(coordinates, (result) => {
        //   if (Cesium.defined(result)) {
        //     // result.name 是地名
        //     console.log(result.name);
        //   }
        // });
        // console.log($vc.Cesium.CesiumWidget)
        if (Cesium.defined(cartesian)) {
            point.value = $vc.viewer.entities.add({
                position: cartesian,
                // point: {
                //   pixelSize: 10,
                //   color: Cesium.Color.RED,
                // },
                billboard: {
                    // 图像地址，URI或Canvas的属性
                    image: '/images/zuobiao-pic.png',
                    // 设置颜色和透明度
                    color: Cesium.Color.WHITE.withAlpha(1),
                    // 高度（以像素为单位）
                    height: 45,
                    // 宽度（以像素为单位）
                    width: 47,
                    // 逆时针旋转
                    rotation: 0,
                    // 大小是否以米为单位
                    sizeInMeters: false,
                    // 相对于坐标的垂直位置
                    verticalOrigin: Cesium.VerticalOrigin.CENTER,
                    // 相对于坐标的水平位置
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    // 该属性指定标签在屏幕空间中距此标签原点的像素偏移量
                    pixelOffset: new Cesium.Cartesian2(0, 0),
                    // 应用于图像的统一比例。比例大于会1.0放大标签，而比例小于会1.0缩小标签。
                    scale: 1.0,
                    // 是否显示
                    show: true
                }
            });
            // 可以添加更多属性，比如点击事件等
        }
    }
    locationBtn()
}

const closeDialog = () => {
    emits("update:homeEventVisible", false);
    selectName.value = ""
    alarmLocation.value = ""
    locationLng.value = ""
    locationLat.value = ""
    if (watchDeviceState) {
        watchDeviceState()
        watchDeviceState = undefined
    }
    if (point.value) {
        $vc.viewer.entities.remove(point.value);
    }
    // 禁用实体的描绘
    $vc.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
}

const uavPopBtn = () => {
    if (watchDeviceState) {
        watchDeviceState()
        watchDeviceState = undefined
    }
    uavPop.value = false
}

// const alertVisible = ref(false)
const orgid = localStorage.getItem("orgid") || "";
const flyHeight = ref()

const treatBtn = () => {
    if (watchDeviceState) {
        watchDeviceState()
        watchDeviceState = undefined
    }
    if (flyHeight.value) {
        // alertVisible.value = true
        // if (flyHeight.value - airObj.value?.basicOsd?.height < 20) {
        //     ElMessage.warning("高度较低，无法执行任务");
        //     return
        // }
        clickAlert({ longitude: locationLng.value, latitude: locationLat.value, sn: deviceOption.value[0].sn, height: flyHeight.value, orgId: orgid }).then(res => {
            ElMessage.success('准备出警')
            uavPop.value = false
            localStorage.setItem("treatValue", "treat")
            sessionStorage.setItem("jobId", res.jobId)
            // emits("update:homeEventVisible", false);
            closeDialog()
        })
    } else {
        ElMessage.warning('请输入出警高度')
    }
}

const stopHomeEventVisibleWatch = watch(
    () => props.homeEventVisible,
    (newVal: boolean) => {
        if (newVal && $vc?.viewer) {
            $vc.viewer.screenSpaceEventHandler.setInputAction(drawPoint, Cesium.ScreenSpaceEventType.LEFT_CLICK);
        }
    }
);

/** 地址联想防抖，减少高频请求与列表替换带来的内存与主线程压力 */
let tipDebounceTimer: ReturnType<typeof setTimeout> | null = null
const stopAlarmLocationWatch = watch(() => alarmLocation.value, (newVal) => {
    if (tipDebounceTimer) {
        clearTimeout(tipDebounceTimer)
        tipDebounceTimer = null
    }
    tipDebounceTimer = setTimeout(() => {
        tipDebounceTimer = null
        if (!newVal) {
            locationList.value = []
            return
        }
        $.ajax({
            url: 'https://restapi.amap.com/v3/assistant/inputtips?parameters',
            type: 'get',
            data: {
                key: '9586abfa77a776cd98133a3f415d4056',
                keywords: newVal,
                output: 'JSON',
                extensions: 'base'
            },
            success: function (result: any) {
                locationList.value = result.tips
            }
        })
    }, 300)
})

onUnmounted(() => {
    if (tipDebounceTimer) {
        clearTimeout(tipDebounceTimer)
        tipDebounceTimer = null
    }
    stopAlarmLocationWatch()
    stopHomeEventVisibleWatch()
    if (watchDeviceState) {
        watchDeviceState()
        watchDeviceState = undefined
    }
    const viewer = $vc?.viewer
    const CesiumGlobal = (globalThis as any).Cesium
    if (viewer && CesiumGlobal?.defined?.(viewer)) {
        try {
            viewer.screenSpaceEventHandler.removeInputAction(CesiumGlobal.ScreenSpaceEventType.LEFT_CLICK)
        } catch {
            /* ignore */
        }
        if (point.value) {
            try {
                viewer.entities.remove(point.value)
            } catch {
                /* ignore */
            }
            point.value = null
        }
    }
})

</script>

<template>
    <div>
        <el-dialog class="home-event-box" modal-class="modal-event" v-model="props.homeEventVisible" title="一键出警："
            draggable :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div class="closeBtn" @click="closeDialog">
                <img src="@/assets/icons/close-btn.png" alt="">
            </div>
            <div class="flex-box">
                <div class="search-box">
                    <div class="dialog-word">输入地址关键字或坐标搜索，或在地图中点选相应点位</div>
                    <el-form label-width="auto" style="width:17.7vw" class="searchForm">
                        <div class="searchBox">
                            <el-form-item label="搜坐标：" class="locitionItem">
                                <el-input v-model="locationLng" placeholder="经度" clearable />
                                <el-input v-model="locationLat" placeholder="纬度" clearable />
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="locationBtn">搜索</el-button>
                            </el-form-item>
                        </div>
                        <div class="searchBox">
                            <el-form-item label="搜地址：" class="searchItem">
                                <el-input v-model="alarmLocation" placeholder="请输入关键词搜索" clearable />
                                <div v-if="alarmLocation !== selectName" class="alarm-select">
                                    <div style="cursor: pointer;padding: 5px;" @click="selectLocation(item)"
                                        v-for="item in locationList" :key="item.id">{{ item.name }}</div>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="locationBtn" class="locationBtn">搜索</el-button>
                            </el-form-item>
                        </div>
                        <div class="searchBox">
                            <el-form-item label="相对机场高度：" class="searchItem">
                                <el-input v-model="flyHeight" placeholder="请输入相对机场高度" clearable />
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="uav-detial">
                    <p class="title">
                        <img src="@/assets/icons/lujing.png" alt="">
                        <span>找到点位附近的机场</span>
                    </p>
                    <p class="word">
                        <span>名称：</span>
                        <span :title="deviceOption ? deviceOption[0].snName : '--'">{{ deviceOption ?
                            deviceOption[0].snName
                            : "--" }}</span>
                    </p>
                    <p class="word">
                        <span>状态：</span>
                        <span>{{ airObj ? theEDockModeCode[airObj.basicOsd?.mode_code + 1] :
                            theEDockModeCode[EDockModeCode.Disconnected + 1] }}</span>
                    </p>
                    <p class="word">
                        <span>距机场：</span>
                        <span>{{ deviceOption ? deviceOption[0].maile : "--" }}m</span>
                    </p>
                    <p class="word">
                        <span>风速：</span>
                        <span>{{ airObj ? airObj.basicOsd?.wind_speed : '--' }}m/s</span>
                    </p>
                    <p class="word">
                        <span>降雨量：</span>
                        <span v-if="airObj && airObj.basicOsd?.rainfall != 0">{{ airObj.basicOsd?.rainfall }}</span>
                        <span v-else>无降雨</span>
                    </p>
                    <div class="Treatbtn" @click="treatBtn" v-if="uavPop">出警</div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<style lang="scss">
.modal-event {
    pointer-events: none;
}

.home-event-box {
    width: 35.7vw;
    height: 29vh;
    background: url("@/assets/icons/chujing-pop.png") no-repeat center;
    background-size: 100% 100%;
    pointer-events: auto;
    position: relative;

    .closeBtn {
        width: 1.2vw;
        height: 2.2vh;
        position: absolute;
        top: 1px;
        right: 1px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .el-dialog__title {
        color: #fff;
        font-family: YouSheBiaoTiHei;
        font-size: 1.5rem;
        font-weight: normal;
        line-height: 3.5vh;
    }

    .flex-box {
        display: flex;

        .search-box {
            width: 17.7vw;
            margin-left: 5px;

            .dialog-word {
                font-family: AlibabaPuHuiTi;
                font-size: .875rem;
                font-weight: 600;
                line-height: 20px;
                background: linear-gradient(180deg, #FFFFFF 25%, #FFEB9B 56%, #FFBB00 72%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                margin-top: 20px;
                margin-bottom: 22px;
            }


            .searchForm {

                .searchBox {
                    width: 17.7vw;
                    height: 2.6vh;
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 1.1vh;

                    .searchItem {
                        margin-right: 0.625rem;
                        margin-bottom: 1.1vh;

                        .el-form-item__label {
                            color: #fff;
                            font-size: .875rem;
                            font-family: AlibabaPuHuiTi;
                        }

                        .el-input {
                            width: 10.3vw;

                            .el-input__wrapper {
                                background: rgba(111, 112, 112, 0.4);
                                // border: 1px solid rgba(108, 209, 255, 0.38);
                                height: 2.6vh;
                                box-shadow: 0 0 0 1px rgba(108, 209, 255, 0.38);

                                .el-input__inner {
                                    color: #fff;
                                }
                            }
                        }

                        .alarm-select {
                            color: #fff;
                            width: 10.3vw;
                            background-color: #126672;
                        }
                    }

                    .locitionItem {
                        margin-right: 0.625rem;
                        margin-bottom: 1.1vh;

                        .el-form-item__label {
                            color: #fff;
                            font-size: .875rem;
                            font-family: AlibabaPuHuiTi;
                        }

                        .el-form-item__content {
                            width: 10.3vw;
                            justify-content: space-between;
                        }

                        .el-input {
                            width: 4.4vw;

                            .el-input__wrapper {
                                background: rgba(111, 112, 112, 0.4);
                                box-shadow: 0 0 0 1px rgba(108, 209, 255, 0.38);
                                height: 2.6vh;

                                .el-input__inner {
                                    color: #fff;
                                }
                            }
                        }

                    }

                    .locationBtn {
                        width: 2.4vw;
                        height: 2.6vh;
                        margin-top: 0.3vh;
                    }
                }
            }
        }

        .uav-detial {
            margin-left: 4.2vw;

            .title {
                font-family: YouSheBiaoTiHei;
                font-size: 16px;
                background: linear-gradient(180deg, #FFFFFF 25%, #9BE2FF 56%, #33CBFF 72%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                display: flex;
                align-items: center;
                margin-top: 1.2vh;
                margin-bottom: 1.5vh;

                img {
                    width: .7vw;
                    height: 1.7vh;
                    margin-right: .3vw;
                }
            }

            .word {
                font-family: AlibabaPuHuiTi;
                font-size: .875rem;
                font-weight: normal;
                color: #fff;
                margin-top: .9vh;
            }

            .Treatbtn {
                width: 3.9vw;
                height: 2vh;
                border-radius: 3px;
                background: linear-gradient(270deg, rgba(253, 202, 0, 0.8) 0%, rgba(248, 128, 0, 0.6) 100%);
                box-sizing: border-box;
                // border: 0.5px solid;
                border-image: linear-gradient(270deg, #FFFFFF 0%, #FAA700 97%) 0.5;
                text-align: center;
                line-height: 2vh;
                font-size: .75rem;
                font-family: AlibabaPuHuiTi;
                color: #fff;
                margin-top: 1.2vh;
                cursor: pointer;
            }
        }
    }


}
</style>